import { Box } from 'components/boxs'
import { DropdownFull } from 'components/dropdown'
import { Icon } from 'components/icon'
import { ModalConfirm } from 'components/modal'
import { Typography } from 'components/typography'
import { DropdownFullItemProps, Icons, TypographyTypes } from 'interfaces'
import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import { VisibilitySettingsBoxProps } from './VisibilitySettingsBox.type'

export const VisibilitySettingsBox: React.FC<VisibilitySettingsBoxProps> = ({
	option,
	control,
	name,
	titleBox,
	titleDropdown,
	requiredConfirmation,
	titleModalConfirmation,
	descriptionModalConfirmation,
	iconModalConfirmation,
	iconBox = Icons.visibility,
	whenIsRequiredConfirmation = 'true',
	childrenModalConfirmation,
	widhtModal,
	labelButtonConfirm,
	reverseButton,
	showCloseButton,
	valueType = 'string'
}): JSX.Element => {
	const initialStateModal = {
		open: false,
		title: '',
		description: '',
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onConfirm: () => {}
	}

	const [modalProps, setModalProps] = useState(initialStateModal)
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const confirmChangeState = (callBack: (...event: any[]) => void): void => {
		if (!requiredConfirmation) return
		if (titleModalConfirmation)
			setModalProps({
				open: true,
				title: titleModalConfirmation,
				description: descriptionModalConfirmation ?? '',
				onConfirm: () => {
					callBack()
					setModalProps(initialStateModal)
				}
			})
	}
	return (
		<Box className="border-none min-h-[178px] mb-6 mt-4 pb-6">
			<>
				<div className="flex flex-row items-center pb-4 gap-2">
					<Icon src={iconBox} className="w-5 h-5 text-black-1" />
					<Typography
						title={titleBox}
						fontLeading="15/18"
						type={TypographyTypes.h3}
						className="text-black-1"
					/>
				</div>
				<div className="border-blue-primary rounded-2xl border-2 p-4 gap-2">
					<Typography
						title={titleDropdown}
						fontLeading="15/18"
						type={TypographyTypes.h3}
						className="text-black-1 mb-4"
					/>
					<Controller
						control={control}
						name={name}
						render={({ field: { onChange, value } }) => {
							return (
								<DropdownFull
									list={option}
									item={
										option.find(e => e.value === value?.toString()) ?? option[0]
									}
									setItem={(e: DropdownFullItemProps) => {
										let valueToSend: string | boolean | DropdownFullItemProps

										if (valueType === 'boolean') {
											valueToSend = e.value === 'true'
										} else if (valueType === 'string') {
											valueToSend = e.value ?? ''
										} else {
											valueToSend = e
										}

										if (
											requiredConfirmation &&
											e.value === whenIsRequiredConfirmation
										) {
											confirmChangeState(() => {
												onChange(Boolean(valueToSend))
											})
											return
										}

										onChange(valueToSend)
									}}
								/>
							)
						}}
					/>
				</div>
				<ModalConfirm
					open={modalProps.open}
					setOpen={() => setModalProps(initialStateModal)}
					hasCancel
					buttonLabelCancel="Cancel"
					buttonLabel={labelButtonConfirm ?? 'Yes'}
					flexButton="row"
					handleCancel={() => setModalProps(initialStateModal)}
					onClickConfirm={modalProps.onConfirm}
					icon={iconModalConfirmation}
					title={modalProps.title}
					descripcion={modalProps.description}
					classNameButton="h-[32px] w-[151px] m-0 !py-0"
					childrenModalConfirmation={childrenModalConfirmation}
					widhtModal={widhtModal}
					reverseButton={reverseButton}
					showCloseButton={showCloseButton}
				/>
			</>
		</Box>
	)
}
